module.exports = __webpack_public_path__ + "static/img/advert_1.3f8675d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CopierSelfprinting/advert_1.png
// module id = csoP
// module chunks = 10